// extracted by mini-css-extract-plugin
export var button = "_ay-0";
export var icon = "_ay-1";